import React from 'react';
import { connect } from 'dva';
import styles from './style.less';
import { getMapStateToProps } from '@/utils/utils';
import { Row, Col, Card, Tag, Button } from 'antd';
import PackageInfoItem from './PackageInfoItem';
import { router } from 'umi';
import { MAX_NUMBER_OF_PACKAGE } from '@/constants/PackageData';
import classNames from 'classnames';

const { Meta } = Card;
interface PackageBodyProps {
  data: any;
  moduleKey: string;
}

const PackageBody: React.FC<PackageBodyProps> = (props: any) => {
  const {
    landing: {
      actionButtonInfo: {
        actionRoute,
        package: { packageText },
      },
    },
    meta: { isMobile },
    helper: { tx },
    data,
    dispatch,
    moduleKey,
  } = props;

  const isThreePackage = data.length === MAX_NUMBER_OF_PACKAGE ? true : false;
  const isTwoPackage = data.length === 2 ? true : false;

  const toggleButton = (selectedPackage: any) => {
    if (moduleKey === 'landing' && actionRoute) {
      // landing action buttons
      router.push(actionRoute);
    } else if (moduleKey === 'user') {
      // user package buttons
      // set clear=true and init=true when setting selectedPackageInfo for the first time
      dispatch({
        type: 'user/setSelectedPackageInfo',
        nameKey: selectedPackage.nameKey,
        price: selectedPackage.price,
        clear: true,
        init: true,
      });
      router.push('/user/package/select-subscription');
    }
  };

  return (
    <Row
      justify="center"
      gutter={[
        { xs: 8, sm: 8, md: 8, lg: 8 },
        { xs: 8, sm: 8, md: 8, lg: 8 },
      ]}
      className={styles.packageBodyContainer}
      style={{
        padding: isThreePackage || isMobile ? '0px 120px' : '0px 340px',
      }}
    >
      {data.map((item: any, idx: any) => (
        <Col
          md={24}
          xl={isTwoPackage ? 24 : 12}
          xxl={isThreePackage ? 8 : 12}
          key={idx}
          className={styles.col}
        >
          <div
            className={styles.packageItemContainer}
            style={{ marginBottom: isTwoPackage || !item.showHeader ? '60px' : 0 }}
          >
            {item.showHeader && (
              <Tag
              // @primary-color 是黑色, 并且这个变量 只在less 文件里生效, 在这里不生效 所以暂时
              //现在改为 transparent

              // className={styles.greenTag}
              // color={item.showHeader && '@primary-color'}
              // style={{
              //   backgroundColor: item.showCurrentPackageHeader ? 'transparent' : '@primary-color',
              //   boxShadow: item.showCurrentPackageHeader && 'none',
              //   border: item.showCurrentPackageHeader && 'none',
              // }}
                className={classNames(styles.greenTag, {
                  [styles.currentPackageHeader]: item.showCurrentPackageHeader,
                  [styles.nonCurrentPackageHeader]: !item.showCurrentPackageHeader,
                })}
              >
                {item.showPopularHeader && (
                  <div className={styles.bigText}>{tx('Package.most.popular')}</div>
                )}
                {item.showCurrentPackageHeader && (
                  <div className={styles.bigText} style={{ color: '#8C8C8C' }}>
                    {tx(`Dashboard.current_package`)}
                  </div>
                )}

                {item.showLandingHeader && (
                  <div>
                    <div className={styles.bigText}>{tx('Package.1-month_free')}</div>
                    <div>{tx('Package.by_invitation')}</div>
                  </div>
                )}
              </Tag>
            )}
            <Card
              className={styles.cardContainer}
              style={{ marginTop: item.showHeader ? 0 : '60px' }}
            >
              <div className={styles.topCardContainer}>
                <div
                  className={styles.cardTitle}
                  style={{ color: item.nameStyle ? item.nameStyle : 'black' }}
                >
                  {tx(item.nameKey)}
                </div>
                <div>xxxxxxxxx</div>
                <div className={styles.cardTitle}>{tx(item.price.monthly)}</div>
                <div
                  className={styles.currencyTitle}
                  style={{ paddingBottom: item.showButton ? 0 : '60px' }}
                >
                  {tx('Package.usd./.month')}
                </div>
                {item.showButton && (
                  <div>
                    <Button
                      type="primary"
                      size="large"
                      shape="round"
                      className={styles.packageButton}
                      onClick={() => toggleButton(item)}
                      style={{
                        backgroundColor: item.buttonStyle ? item.buttonStyle : item.nameStyle,
                        // @primary-color 是黑色, 并且这个变量 只在less 文件里生效, 在这里不生效
                        color: item.buttonTextStyle ? item.buttonTextStyle : '@primary-color',
                        borderColor: item.nameStyle,
                      }}
                    >
                      {tx(`${item.showSelectButton ? 'select' : packageText}`)}
                    </Button>
                  </div>
                )}
              </div>
              <Meta style={{ paddingTop: '26px' }} description={<PackageInfoItem {...item} />} />
            </Card>
          </div>
        </Col>
      ))}
    </Row>
  );
};

export default connect(getMapStateToProps(['meta', 'loading', 'landing']))(PackageBody);
